// Kanonisk «track» — det fusjonerte objektet SKADE-COP viser på kartet.
// Alle kilder (SPARK, CoT/TAK, ADS-B, sivil innmelding) normaliseres til denne
// før rendering, med tillitsgrad og kildesporing (jf. Delta/Griselda-lærdommen:
// hvert produkt må kunne spores til kilde + tillitsnivå).
import { z } from 'zod';
export const Affiliation = z.enum(['friend', 'hostile', 'neutral', 'unknown']);
/**
 * Hva en høyde er målt FRA. Uten dette er et høydetall verdiløst i et 3D-kart.
 *
 * `msl` — over havflaten (middelvannstand). Referansen for sjømål og for
 *   luftfartøy meldt i fot MSL.
 * `agl` — over bakken/terrenget under objektet. Det droneførere tenker i.
 * `trykk` — trykkhøyde (standardatmosfære). Det ADS-B og de fleste luftfartøy
 *   faktisk sender. Kan avvike titalls meter fra MSL og MÅ ikke blandes med den.
 * `hae` — over WGS84-ellipsoiden. Det GNSS-mottakere gir rått, og det som er
 *   riktig å regne geometri i — men det er ikke det noen sier over radio.
 */
export const HoydeReferanse = z.enum(['msl', 'agl', 'trykk', 'hae']);
export const TrackKind = z.enum([
    'unit', // egen/venn styrke (BFT/PLI)
    'person', // ENKELTPERSON — en navngitt GNÅ-bruker bundet til en ORBAT-node
    'sensor', // SPARK-node
    'detection', // skudd/drone-kilde m.m.
    'point', // taktisk punkt (rally/target/danger)
    'report', // stridsmelding
]);
/**
 * Samme form som `TrackOrg`, som Zod-skjema.
 *
 * ⚠ ÉN KILDE (§3). Formen var kopiert inline i `kamerakalibrering.ts`, og en ny
 * modul ville gjort det til tre kopier. Tre kopier av et RBAC-relevant felt er
 * hvordan én av dem etter hvert får en annen maksimallengde enn de andre — og da
 * avviser hubben et org-merke den selv har utstedt.
 */
export const TrackOrgSchema = z.object({
    district: z.string().max(80).optional(),
    area: z.string().max(80).optional(),
    troop: z.string().max(80).optional(),
    team: z.string().max(80).optional(),
});
// ── Identifikasjonsnivå ──────────────────────────────────────────────────────
/**
 * Ordinal identifikasjonsstige, STRUKTURELT atskilt fra `affiliation`
 * (operatørvurdering av side) og `confidence`/`trust` (eksistens-/
 * posisjonssikkerhet). Utledes alltid av hvilke observasjonstyper som faktisk
 * bidrar (se `idNivaa()` i @skade/fusion) — det er aldri noe en operatør
 * skriver inn manuelt, og det er aldri en gjettet klassetabell: SKADE har
 * ingen databasekobling å slå opp identitet i, i motsetning til systemer som
 * har en AIS-/kystradar-database å gate identifikasjonen på.
 */
export const IdNivaa = z.enum(['ukjent', 'domene', 'type', 'klasse', 'presis']);
export const ID_NIVAA_LABEL = {
    ukjent: 'Ukjent — ingen observasjon sier noe om hva dette er',
    domene: 'Domene — sett (peiling/radar), men ikke klassifisert',
    type: 'Type — akustisk eller RF-klasse identifisert',
    klasse: 'Klasse — visuelt klassifisert',
    presis: 'Presis — visuelt bekreftet MED klassifisering',
};
//# sourceMappingURL=track.js.map